import { FC, useEffect } from "react";
import { Link, Stack } from "@mui/material";
import { BodyText, HeadingText1 } from "../styles/styledComponents";
import ScreenBase from "./ScreenBase";
import { useLicenses } from "../contexts/licenseContext";

const LicenseSuccessScreen: FC = () => {
	const { clearCart } = useLicenses();

	useEffect(() => {
		clearCart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ScreenBase
			scrollableChildren={(
				<Stack component="section" spacing={4}>
					<HeadingText1>Payment Received!</HeadingText1>
					<BodyText>
						Thank you for your purchase. Your zero-attribution license PDF is being generated
						now and will be emailed to you shortly &mdash; it usually only takes a minute or two.
					</BodyText>
					<BodyText>
						Didn't receive it after a while? Double-check your spam folder, or{' '}
						<Link href="/contact">contact us</Link> and we'll sort it out.
					</BodyText>
					<Link href="/tunes">Browse more tunes</Link>
				</Stack>
			)}
		/>
	);
};

export default LicenseSuccessScreen;
